// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2jr_f","box":"WorkspacesBox_box__3bMNA","node":"WorkspacesBox_node__2Sbxi"};